<template>
    <div class="AudioInfo">
        <div class="AudioInfo__Preview">
            <div class="AudioInfo__ImgContainer">
                <img
                    class="AudioInfo__ImgDefault"
                    :src="defaultCover"
                    alt="" />
                <img
                    v-if="trackCover"
                    class="AudioInfo__Img"
                    :src="trackCover"
                    :alt="trackTitle"
                    @error="showCover = false" />
            </div>
        </div>
        <div class="AudioInfo__Body">
            <div class="AudioInfo__MainText">
                <div class="AudioInfo__Title">
                    {{ trackTitle }}
                </div>
                <div class="AudioInfo__Episode" v-if="episodeTitle">
                    {{ episodeTitle }}
                </div>
            </div>
            <span class="AudioInfo__EpisodeLength">
                {{ durationFormatted }}
            </span>
        </div>
    </div>
</template>


<script>
import { formatDynamicDuration } from '../utils/index.js';
import defaultCover from '../../../assets/svg/audio-default-cover.svg';

export default {
    name: 'AudioInfo',
    props: {
        trackTitle: {
            type: String,
            default: 'Add Title',
        },
        trackCover: {
            type: String,
            default: '',
        },
        episodeTitle: {
            type: String,
            default: 'Add Episode Title',
        },
        duration: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        durationFormatted() {
            return formatDynamicDuration(this.duration);
        },
    },
    data() {
        return {
            showCover: true,
            defaultCover,
        };
    },
    watch: {
        trackCover() {
            this.showCover = true;
        },
    },
};
</script>


<style lang="scss" scoped>
.AudioInfo {
    display: flex;
    gap: 12px;
}

.AudioInfo__Preview {
    flex-shrink: 0;
}

.AudioInfo__ImgContainer {
    position: relative;
    z-index: 0;
    width: 64px;
    height: 64px;
    overflow: hidden;
    background-color: #f0f0f0;
    border: 1px solid #d6d9df;
    border-radius: 50%;
}

.AudioInfo__ImgDefault {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
}

.AudioInfo__Img {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
}

.AudioInfo__Body {
    display: flex;
    flex-direction: column;
    gap: 5px;
    justify-content: center;
    max-width: 325px;
}

.AudioInfo__MainText {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.AudioInfo__Title {
    margin: 0;

    @include typo-additional-demi;
}

.AudioInfo__Episode {
    margin: 0;
    color: $gray-deep;

    @include typo-additional-demi;
}

.AudioInfo__Title,
.AudioInfo__Episode {
    @include line-clamp(1, 16);
}

.AudioInfo__EpisodeLength {
    @include typo-subsecondary-demi;
}
</style>
